var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.6499 5.24188C12.6499 5.28948 12.2768 10.008 12.0637 11.9938C11.9303 13.2125 11.1447 13.9517 9.96623 13.9727C9.06078 13.993 8.1744 14 7.30231 14C6.37644 14 5.47099 13.993 4.5921 13.9727C3.45314 13.9454 2.66683 13.1915 2.54021 11.9938C2.32099 10.001 1.95473 5.28948 1.94792 5.24188C1.94111 5.09839 1.98741 4.96189 2.08136 4.85129C2.17394 4.7491 2.30738 4.6875 2.44762 4.6875H12.157C12.2966 4.6875 12.4232 4.7491 12.5233 4.85129C12.6165 4.96189 12.6635 5.09839 12.6499 5.24188Z",
    fill: "#FF5A62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.598 2.7838C13.598 2.49611 13.3713 2.27072 13.099 2.27072H11.058C10.6428 2.27072 10.2819 1.97533 10.1893 1.55885L10.075 1.04856C9.91499 0.431885 9.36287 0 8.74336 0H5.85342C5.22709 0 4.68042 0.431885 4.51431 1.08216L4.40743 1.55955C4.31416 1.97533 3.95334 2.27072 3.53874 2.27072H1.49774C1.22475 2.27072 0.998047 2.49611 0.998047 2.7838V3.04979C0.998047 3.33048 1.22475 3.56288 1.49774 3.56288H13.099C13.3713 3.56288 13.598 3.33048 13.598 3.04979V2.7838Z",
    fill: "#FF5A62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.1458dd22.svg";
export { ForwardRef as ReactComponent };